import ptBR from 'date-fns/locale/pt-BR'
import React from 'react'
import { MdDateRange } from 'react-icons/md'

import DateFnsUtils from '@date-io/date-fns'
import { StylesProvider } from '@material-ui/core/styles'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker as KeyboardDatePickerComponent,
} from '@material-ui/pickers'

import { IKeyboardDatePicker } from './KeyboardDatePickerComponent.types'
import { Container, StyledError } from './styles'

const KeyboardDatePicker: React.FunctionComponent<IKeyboardDatePicker> = ({
  selectedDate,
  handleDateChange,
  autoOk,
  inputReadOnly,
  label,
  onBlur,
  errorMessage,
  inputVariant,
}) => {
  return (
    <Container>
      <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
        <StylesProvider injectFirst>
          <KeyboardDatePickerComponent
            InputProps={{ readOnly: inputReadOnly, disableUnderline: true }}
            margin="normal"
            variant="inline"
            inputVariant={inputVariant || 'outlined'}
            format="dd/MM/yyyy"
            placeholder={label}
            value={selectedDate}
            invalidDateMessage=""
            onChange={handleDateChange}
            maxDateMessage="A data não deve ser posterior à data máxima"
            minDateMessage="A data não deve ser anterior à data mínima"
            autoOk={autoOk}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            keyboardIcon={<MdDateRange size={20} />}
            onBlur={onBlur}
          />
        </StylesProvider>
      </MuiPickersUtilsProvider>
      <StyledError>{errorMessage}</StyledError>
    </Container>
  )
}

export default KeyboardDatePicker
